var formatMaskedPhone = function (value) {
    return value.replace(/(.{3})(.{3})(.{4})/, "$1-$2-$3");
};
export default formatMaskedPhone;
